import { useOrientation } from '@/hooks/useOrientation';

const useBaseSize = () => {
    const { isHorizontal } = useOrientation();

    const baseWidth = isHorizontal ? 1920 : 1080;
    const baseHeight = isHorizontal ? 1080 : 1920;

    return { baseWidth, baseHeight };
};

export default useBaseSize;
